export default __webpack_public_path__ + "static/media/gif_loading.62353263.gif";